import DbDraftEmail, {EmailMimeContent} from "../domain/DbDraftEmail";
import {DbAttachment} from "../db/DbSchema";
import quotedPrintable from "quoted-printable";
import utf8 from "utf8";
import {MimeWriterPart} from "../parsers/MimeWriter";
import {ContentType} from "./ContentTypes";
import {uuid} from "./Uuid";
import {DB} from "../db/DbManager";
import {createTrackingImage, replaceImageUrlsWithContentIds} from "./MimeUtil";

export async function createMimeEmailContent(draftEmail: DbDraftEmail, content: EmailMimeContent, attachments: DbAttachment[]): Promise<void> {
    const VerbatimHeaders = content.VerbatimHeaders;

    const trackingImage = createTrackingImage(content.TrackingImageId);
    const fullEmailText = replaceImageUrlsWithContentIds(draftEmail.BodyText + draftEmail.ExtendedBodyText ?? "") + trackingImage;  // The user content of the email

    const encodedContent = quotedPrintable.encode(utf8.encode(fullEmailText));
    if (attachments.length > 0) {
        const rootPart: MimeWriterPart = new MimeWriterPart(ContentType.MultipartMixed, [], undefined, uuid());

        const messagePart = MimeWriterPart.createInlinePart(ContentType.HtmlTextUtf8, "quoted-printable", encodedContent);
        rootPart.addSubPart(messagePart);

        await addAttachmentsToMimePart(rootPart, attachments);

        VerbatimHeaders["Content-Type"] = rootPart.getContentType();
        content.VerbatimContentData = await rootPart.asString();
    } else {
        VerbatimHeaders["Content-Type"] = ContentType.HtmlTextUtf8;
        VerbatimHeaders["Content-Type"] = ContentType.HtmlTextUtf8;
        VerbatimHeaders["Content-Transfer-Encoding"] = "quoted-printable";
        content.VerbatimContentData = encodedContent;
    }
}

export async function addAttachmentsToMimePart(part: MimeWriterPart, attachments: DbAttachment[]): Promise<void> {
    for (const attachment of attachments) {
        const data = await DB.getEmailAttachmentData(attachment.attachmentUid);
        if (!data) {
            throw Error(`Attachment data for '${attachment.name}' not found. Please re-attach this to the email and try again`);
        }
        part.addSubPart(MimeWriterPart.createAttachmentPart(attachment.contentType, "base64", attachment.name, data, attachment.contentId));
    }
}
